import Button from '@/components/atoms/Button';
import { Card } from '@/components/atoms/Card';
import TossGuideImg1 from '@/assets/images/TossGuide1.png';
import TossGuideImg2 from '@/assets/images/TossGuide2.png';
import TossGuideImg3 from '@/assets/images/TossGuide3.png';
import TossGuideImg4 from '@/assets/images/TossGuide4.png';
import { toast } from 'react-toastify';

const INVITE_EMAIL = 'task-manager@cplat.io';

export const TossGuide = () => {
  return (
    <Card className="space-y-[30px] p-[30px]">
      {GuideItems.map((item) => (
        <div className="space-y-5">
          <div className="flex items-center justify-between">
            <div className="flex gap-1.5">
              <Badge label={item.number} />
              <div className="mt-px">{item.title}</div>
            </div>
            {item.button && item.button}
          </div>
          {item.image && (
            <div className="flex justify-center px-[30px]">
              <img src={item.image} className="w-full" />
            </div>
          )}
        </div>
      ))}
    </Card>
  );
};

const Badge = ({ label }: { label: number }) => {
  return (
    <span className=" flex h-[22px] w-[22px] items-center  justify-center rounded-[4px] bg-blue-400 text-white Caption2B12">
      {label}
    </span>
  );
};

const GuideItems = [
  {
    number: 1,
    title: (
      <>
        <span
          className="cursor-pointer font-bold"
          onClick={() => window.open('https://business.toss.im/account/sign-in')}
        >
          토스쇼핑 파트너스
        </span>{' '}
        접속
      </>
    ),
  },
  {
    number: 2,
    title: (
      <>
        <span className="font-bold">가맹점·계정 관리</span> 선택
      </>
    ),
    image: TossGuideImg1,
  },
  {
    number: 3,
    title: (
      <>
        <span className="font-bold">멤버 관리 {'>'} 초대하기</span> 선택
      </>
    ),
    image: TossGuideImg2,
  },
  {
    number: 4,
    title: (
      <>
        초대할 이메일 <span className="font-bold">{INVITE_EMAIL}</span>
        <br />
        입력 후 <span className="font-bold">초대하기</span> 선택
      </>
    ),
    button: (
      <Button
        variant="point_default"
        size="sm"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(INVITE_EMAIL);
            toast(
              <div className="flex items-center gap-2">
                <span>✅</span> 메일 주소 복사가 완료되었어요
              </div>,
            );
          } catch (error) {
            console.error(error);
          }
        }}
      >
        메일 복사하기
      </Button>
    ),
    image: TossGuideImg3,
  },
  {
    number: 5,
    title: (
      <>
        <span className="font-bold">가맹점·계정 관리 {'>'} 쇼핑몰 통합관리 솔루션 연동</span>에 있는
        셀러 ID
        <br />
        셀러박스에 입력해주세요.
        <br />
        셀러 ID가 없는 경우, 키 발급하기 버튼을 누르면 확인하실 수 있어요.
      </>
    ),
    image: TossGuideImg4,
  },
  {
    number: 6,
    title: (
      <>
        <span className="font-bold">연동 완료까지 영업일 기준 하루 정도 소요 돼요.</span>
        <br />
        연동이 완료되면 푸시로 알려드릴게요.
      </>
    ),
  },
];
